import { timeFormatsEnum } from '../enums/time-formats.enum';

export class TimeFormatModel {
    id: number;
    name: string;
    value: string;
    momentFormat: string;
    twigFormat: string;
}

export const timeFormats: TimeFormatModel[] = [
    {
        id: timeFormatsEnum.twelveHour,
        name: 'AM/PM',
        value: 'hh:mm aa',
        momentFormat: 'hh:mm A',
        twigFormat: 'g:ia'
    },
    {
        id: timeFormatsEnum.twentyFourHour,
        name: '24 Hour',
        value: 'HH:mm',
        momentFormat: 'HH:mm',
        twigFormat: 'H:i'
    },
];

